import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.404976 0.405022C0.678343 0.131655 1.12156 0.131655 1.39493 0.405022L6.49995 5.51005L11.605 0.405022C11.8783 0.131655 12.3216 0.131655 12.5949 0.405022C12.8683 0.678389 12.8683 1.1216 12.5949 1.39497L7.4899 6.5L12.5949 11.605C12.8683 11.8784 12.8683 12.3216 12.5949 12.595C12.3216 12.8683 11.8783 12.8683 11.605 12.595L6.49995 7.48995L1.39493 12.595C1.12156 12.8683 0.678344 12.8683 0.404977 12.595C0.13161 12.3216 0.13161 11.8784 0.404977 11.605L5.51 6.5L0.404976 1.39497C0.131609 1.1216 0.131609 0.678389 0.404976 0.405022Z"
			fill="black"
		/>
	</svg>
);
export { SvgComponent as XIcon };
